var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccordionArrow = function SvgAccordionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F848E",
    d: "M10.018 7.5c.195 0 .384.068.534.193l5 4.166a.835.835 0 1 1-1.067 1.284l-4.467-3.734-4.466 3.6a.834.834 0 0 1-1.175-.125.833.833 0 0 1 .116-1.216l5-4.025a.83.83 0 0 1 .525-.142"
  })));
};
export default SvgAccordionArrow;